/**
 * NIBE heat pump status bitmask decoder.
 *
 * Covers parameters that carry a bitmask operational-state value rather than
 * a plain enum.  The set below includes the most common NIBE status registers
 * observed via myUplink on F/S/VVM-series heat pumps.
 *
 * Bit definitions (based on NIBE MODBUS manager documentation):
 *   Bit  0 = 1        → Heating
 *   Bit  1 = 2        → Hot Water
 *   Bit  2 = 4        → Cooling
 *   Bit  3 = 8        → Pool / Solar
 *   Bit  4 = 16       → Defrost
 *   Bit  5 = 32       → Crankcase heater
 *   Bit  6 = 64       → Immersion heater (step 1)
 *   Bit  7 = 128      → Immersion heater (step 2)
 *   Bit  8 = 256      → Additional heat (step 1)
 *   Bit  9 = 512      → Additional heat (step 2)
 *   Bit 10 = 1024     → Additional heat (step 3)
 *   Bit 11 = 2048     → Compressor running
 *   Bit 12 = 4096     → Heating circuit pump running
 *   Bit 13 = 8192     → DHW circulation pump running
 *   Bit 14 = 16384    → Brine / source pump running
 *   Bit 15 = 32768    → External circulation pump
 *   Bit 20 = 1048576  → Cooling active (older firmware)
 */

export const NIBE_STATUS_PARAM_IDS = new Set([
    '50096',   // STATUS circuit 1
    '50097',   // STATUS circuit 2
    '44064',   // Operational mode status
    '10012',   // System status (VVM/SMO)
    '40940',   // Operational mode (some models)
]);

const STATUS_BITS: [number, string][] = [
    [1,       'Värme'],
    [2,       'Varmvatten'],
    [4,       'Kyla'],
    [8,       'Pool/sol'],
    [16,      'Avfrostning'],
    [32,      'Vevhusvärmare'],
    [64,      'Elpatron 1'],
    [128,     'Elpatron 2'],
    [256,     'Tillskottsvärme steg 1'],
    [512,     'Tillskottsvärme steg 2'],
    [1024,    'Tillskottsvärme steg 3'],
    [2048,    'Kompressor'],
    [4096,    'Värmebärarpump'],
    [8192,    'Varmvattencirkulation'],
    [16384,   'Köldbärarpump'],
    [32768,   'Extern cirkulationspump'],
    [1048576, 'Kyla (äldre modeller)'],
];

export function decodeNibeStatus(value: number): string {
    const modes: string[] = [];
    for (const [bit, label] of STATUS_BITS) {
        if (value & bit) modes.push(label);
    }
    return modes.length > 0 ? modes.join(' + ') : 'Vilar';
}
